module.exports = __webpack_public_path__ + "static/media/shape_1.240adfe2.png";